module.exports = __webpack_public_path__ + "static/oid-el-ruido-de-rotas-cadenas_detail1-2010-53452aee2507c74f83451af5d8f3f466.jpg";